export function moveItem<T>(list: readonly T[], from: number, to: number) {
  if (to >= list.length) throw new TypeError('Destination is out of bounds');
  if (from >= list.length) throw new TypeError('Source is out of bounds');

  const next = [...list];
  const fromVal = next[from]!;
  next.splice(from, 1);
  next.splice(to, 0, fromVal);
  return next;
}
